<template>
	<div class="staff-boxs">
        <div class="top-bar com-model m-b-24">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/index/finance' }">财务管理</el-breadcrumb-item>
                <el-breadcrumb-item>设置支付密码</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="staffmanage">
            <div class="st-change-item st-change-item1" style="padding-top:30px;">
                <div class="tit titrequire" placeholder="请输入密码">新密码</div>
                <input type="password" class="inp">
            </div>
            <div class="st-change-item st-change-item1">
                <div class="tit titrequire">再次输入</div>
                <input type="password" class="inp" placeholder="请再次输入密码">
            </div>
            <div class="stepbtn">完成</div>
        </div>
    </div>
</template>
<script>
	export default{
		data(){
			return {
				a:1
			}
		}
	}


</script>
<style scoped lang="less">
@import url('../../assets/less/base.less');
.top-bar {
  padding: 11px 24px;
}
	@import "../../assets/css/variable";
    // @import "../../assets/css/finance";
    @import "../../assets/css/staff";
</style>



// WEBPACK FOOTER //
// setPayPassword.vue?b64358ac